import { Loader2 } from 'lucide-react';

interface StartupProgressProps {
  progress?: {
    phase: string;
    percent: number;
    details?: string;
    startedAt: string;
    completedAt?: string;
  };
  fallbackLabel?: string;
}

export function StartupProgress({ progress, fallbackLabel = 'Starting server...' }: StartupProgressProps) {
  const phase = progress?.phase || fallbackLabel;
  const percent = progress?.percent || 0;

  const elapsed = progress?.startedAt 
    ? Math.floor((Date.now() - new Date(progress.startedAt).getTime()) / 1000)
    : 0;

  const formatElapsed = (seconds: number) => {
    if (seconds < 60) return `${seconds}s`;
    return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
  };

  return (
    <div className="card" style={{ background: 'var(--dark-800)', border: '1px solid var(--dark-600)' }}>
      <div style={{ padding: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
          <Loader2 size={20} style={{ color: 'var(--neon-400)', animation: 'spin 1s linear infinite' }} />
          <span style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-primary)' }}>
            {phase}
          </span>
        </div>

        <div className="progress-bar" style={{ height: '8px', marginBottom: '0.75rem' }}>
          <div 
            className="progress-fill"
            style={{ 
              width: `${percent}%`, 
              transition: 'width 0.5s ease',
              ...(percent < 100 ? {} : { animation: 'none' })
            }} 
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
          <span>{percent}%</span>
          {elapsed > 0 && <span>{formatElapsed(elapsed)}</span>}
        </div>
      </div>
    </div>
  );
}
